/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type billing_PayerRequest = {
    /**
     * ContactID of the payer (optional when FamilyGroupID is provided)
     */
    contact_id?: string;
    /**
     * FamilyGroupID of the payer (optional when ContactID is provided)
     */
    family_group_id?: string;
    /**
     * PayerType (CONTACT or FAMILY_GROUP)
     */
    payer_type: billing_PayerRequest.payer_type;
    /**
     * PercentageShare of the invoice (1-100) (required)
     */
    percentage_share: number;
};
export namespace billing_PayerRequest {
    /**
     * PayerType (CONTACT or FAMILY_GROUP)
     */
    export enum payer_type {
        CONTACT = 'CONTACT',
        FAMILY_GROUP = 'FAMILY_GROUP',
    }
}

